export const TestimonialCard = ({ t, large = false }) => (
  <figure
    className="relative flex flex-col h-full border border-[rgba(169,129,47,0.26)] bg-canvas p-8 md:p-10 hover:border-gold transition-colors duration-500"
    data-testid={`testimonial-${t.id}`}
  >
    <span
      className="font-display text-gold/40 leading-none select-none"
      style={{ fontSize: large ? "5rem" : "3.5rem" }}
      aria-hidden="true"
    >
      &ldquo;
    </span>
    <blockquote
      className={`-mt-6 text-ink leading-relaxed ${
        large ? "font-display text-2xl md:text-3xl leading-[1.35]" : "flex-1 text-[15px] md:text-base"
      }`}
    >
      {t.quote}
    </blockquote>
    <figcaption className="mt-8 pt-6 border-t border-[rgba(169,129,47,0.26)]">
      <span className="block font-display text-lg text-ink">{t.author}</span>
      <span className="block mt-1 text-[10px] uppercase tracking-[0.24em] text-gold">
        {t.role} · {t.city}
      </span>
    </figcaption>
  </figure>
);

export default TestimonialCard;
